export default __webpack_public_path__ + "static/media/Diminished Snowpack 95fb500c54f2489783f15a0ae0b72bd6.7f24519f.md";